// Pop-up: the raw Google-sheet row behind a tip.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { fmtDate, fmtTime } from './helpers.js';

export default function RawRowModal({ rawRow, refresh, setRawRow }) {
  return (
    <>
      {rawRow && (
        <div className="modal-backdrop" onClick={() => setRawRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 600, maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto' }}>
            <h3>Raw form data — {rawRow.licensePlate} · {fmtDate(rawRow.date)} {fmtTime(rawRow.arrivalTime)}</h3>
            <table className="fs-table tidy" style={{ marginTop: '0.5rem' }}>
              <tbody>
                {Object.entries(rawRow._raw || {}).map(([k, v]) => (
                  <tr key={k}><td style={{ color: '#666', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{k}</td><td>{String(v)}</td></tr>
                ))}
              </tbody>
            </table>
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setRawRow(null)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
